import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { config } from './config';

export const api = axios.create({
  baseURL: config.apiUrl,
  timeout: 15000,
});

api.interceptors.request.use(async (req) => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (token) req.headers.Authorization = `Bearer ${token}`;
  } catch {
    // sin sesión — la petición devolverá 401 y lo maneja la vista
  }
  return req;
});
